import React from 'react';
import PropTypes from 'prop-types';
import { LinkElement } from '@els/els-react--link-element';
import InnerHTML from '@Components/InnerHTML';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ReactReactionDetailsHelper from '@Components/Results/services/react-reaction-details-helper.service';

export default function TargetCell({ metadata, value }) {
  return (
    value && (
      <span className="rx-table-targets-list">
        {value.map((data, index) =>
          data ? (
            <span key={data.targetId || index}>
              <LinkElement
                inline
                noExternalIcon
                href="#"
                navigation
                onClick={(e) => {
                  e.preventDefault();
                  ReactReactionDetailsHelper.goToContext('tgitems', { id: data.targetId }, metadata);
                }}
                data-e2e="target-cell-link">
                <InnerHTML tag="span" html={data.targets} />
              </LinkElement>
            </span>
          ) : null
        )}
      </span>
    )
  );
}

TargetCell.propTypes = {
  metadata: MetadataPropTypesShape,
  value: PropTypes.array.isRequired,
};
